import { useMemo } from "react";
import { useSearchParams } from "react-router";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useMe } from "@/lib/hooks/use-clients";
import { DashboardPage } from "./dashboard/dashboard-page";

/**
 * `/` is your own User Dashboard; admins open `/?dashboard=performance` or
 * `/?user=<id>`. For everyone else the parameters are ignored — they only have
 * their own dashboard, and the API refuses the rest anyway.
 */
export default function Page() {
  const { me } = useMe();
  const [searchParams] = useSearchParams();
  const isAdmin = me?.permissions?.includes("admin") ?? false;
  const currentUserId = me?.id ?? "";

  const dashboardParam = searchParams.get("dashboard");
  const userParam = searchParams.get("user");
  const target = useMemo<DashboardTarget>(() => {
    if (isAdmin && dashboardParam === "performance") return { dashboard: "performance" };
    if (isAdmin && userParam && userParam !== currentUserId) {
      return { dashboard: "user", forUserId: userParam };
    }
    return { dashboard: "user" };
  }, [isAdmin, dashboardParam, userParam, currentUserId]);

  if (!me) return null;
  return <DashboardPage isAdmin={isAdmin} currentUserId={currentUserId} target={target} />;
}
